/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Arrow from 'src/assets/arrow-left-black.svg';

import {
  CommonDropdown,
  CommonInput,
  FormErrorWrap,
  RegularButton,
  ICommonDropdownOption,
  FullScreenLoading,
  DatePicker,
} from 'pg-ui-library';
import {
  Container,
  CardContainer,
  HelpForm,
  PageTitle,
  FormInputWrapper,
  NavTextLink,
  ArrowBack,
  HeaderItemLeft,
  ModuleLine,
} from './createStyles';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { supportDeskOptions, supportDeskSubmodules } from '../support-desk/support-dropdown';
import { useAddInvoice } from './mutations/invoice.mutation';
import { InvoiceFormValues } from 'src/interfaces/invoice';
import EmployeesService, { IEmployeeDropdown } from 'src/services/employees.service';
import InvoiceService from 'src/services/invoice.service';

export const assignmentOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: 'Test Assignment 1',
    value: 'A1234',
  },
  {
    key: '2',
    label: 'Test Assignment 2',
    value: 'A5678',
  },
];

export const toISODate = (date: string | Date): string => {
  if (date instanceof Date) return date.toISOString();
  return new Date(date).toISOString();
};

const formatDateOnly = (date: Date | null | undefined): string => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const CreateInvoice: React.FC = () => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState<ICommonDropdownOption[]>(
    supportDeskSubmodules[supportDeskOptions[0].value]
  );

  const addInvoice = useAddInvoice();
  const navigate = useNavigate();

  const [employeeSearch, setEmployeeSearch] = useState('');
  const [employees, setEmployees] = useState<IEmployeeDropdown[]>([]);
  const [employeeOptions, setEmployeeOptions] = useState<ICommonDropdownOption[]>([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<IEmployeeDropdown | null>(null);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [assignmentsUser, setAssignmentsUser] = useState([]);

  const [assignmentsLoading, setAssignmentsLoading] = useState(false);
  const [assignmentOptions, setAssignmentOptions] = useState<ICommonDropdownOption[]>([]);

  const [minPeriodStartDate, setMinPeriodStartDate] = useState<Date | null>(null);

  const [contractStartDate, setContractStartDate] = useState<Date | null>(null);
  const [contractEndDate, setContractEndDate] = useState<Date | null>(null);

  const assignmentOptionsWithBlank: ICommonDropdownOption[] = [
    {
      key: '',
      label: 'Select',
      value: '',
    },
    ...assignmentOptions,
  ];

  useEffect(() => {
    if (!employeeSearch || employeeSearch.length < 2) {
      setEmployeeOptions([]);
      setEmployees([]);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        setLoadingEmployees(true);

        const data = await EmployeesService.getEmployeeDropdown(employeeSearch);
        setEmployees(data);

        setEmployeeOptions(
          data.map(emp => ({
            key: emp.employeeId,
            value: emp.employeeId,
            label: `${emp.firstName} ${emp.middleName ?? ''} ${emp.lastName}`.trim(),
          }))
        );
      } catch (error) {
        console.error('Employee dropdown search failed', error);
      } finally {
        setLoadingEmployees(false);
      }
    }, 400); // debounce

    return () => clearTimeout(timer);
  }, [employeeSearch]);

  useEffect(() => {
    if (!selectedEmployee) return;

    const fullName = `${selectedEmployee.firstName} ${selectedEmployee.middleName ?? ''} ${
      selectedEmployee.lastName
    }`.trim();

    // formik.setFieldValue(
    //   'notes',
    //   `Expense created for ${fullName}${selectedEmployee.email ? ` (${selectedEmployee.email})` : ''}`
    // );
  }, [selectedEmployee]);

  const formatDate = (date?: string | null) => {
    if (!date) return 'Open';
    return date.split('T')[0];
  };

  const handleEmployeeSelect = async (employeeId: string) => {
    formik.setFieldValue('assignmentId', '');
    formik.setFieldValue('assignmentName', '');
    formik.setFieldValue('clientId', '');
    formik.setFieldValue('clientName', '');
    formik.setFieldValue('companyName', '');
    formik.setFieldValue('supplierName', '');
    formik.setFieldValue('jobTitle', '');
    formik.setFieldValue('hireType', '');
    formik.setFieldValue('billRate', '');
    formik.setFieldValue('payRate', '');
    formik.setFieldValue('rateMarkup', '');
    formik.setFieldValue('currency', '');
    formik.setFieldValue('approverEmail', '');
    formik.setFieldValue('approverName', '');
    formik.setFieldValue('division', '');
    formik.setFieldValue('billingCompany', '');
    formik.setFieldValue('departments', '');
    formik.setFieldValue('clientId', '');
    formik.setFieldValue('clientName', '');
    formik.setFieldValue('projectCode', '');

    const emp = employees.find(e => e.employeeId === employeeId) || null;
    if (!emp) return;

    setSelectedEmployee(emp);

    formik.setFieldValue('employeeId', emp.employeeId, true);
    formik.setFieldValue('userId', emp.userId, true);
    formik.setFieldValue('email', emp.email ?? '', true);
    setSelectedUserId(emp.userId);

    // 🔥 start loader
    setAssignmentsLoading(true);
    setAssignmentOptions([]);
    formik.setFieldValue('assignmentId', '');

    if (emp.personnelNumber) {
      try {
        const response = await InvoiceService.fetchAssignmentsByPersonalNumber({
          personnelNumber: emp.personnelNumber,
        });

        const items = response?.data?.vw_msd_jd_assignments?.items ?? [];

        setAssignmentsUser(items);

        const mappedOptions: ICommonDropdownOption[] = items.map((item: any) => ({
          key: item.ASSIGNMENT_ID,
          value: item.ASSIGNMENT_ID,
          label: `${item.JOBTITLE} (${item.ASSIGNMENT_ID}) - ${item.CLIENT_NAME} (${formatDate(
            item.CONTRACT_START_DATE
          )} - ${formatDate(item.CONTRACT_END_DATE)})`,
        }));

        setAssignmentOptions(mappedOptions);
      } catch (error) {
        console.error('Failed to fetch assignments', error);
        setAssignmentOptions([]);
      } finally {
        setAssignmentsLoading(false);
      }
    }

    // auto-hide employee dropdown
    setEmployeeSearch('');
    setEmployeeOptions([]);
    setEmployees([]);
  };

  const validationSchema = yup.object({
    invoiceAmount: yup.string().required('Invoice Amount is required'),
    totalUnits: yup.string().required('Total Units is required'),
    assignmentId: yup.string().required('Assignment is required'),
    invoiceDate: yup.date().nullable().required('Invoice date is required'),
    periodStart: yup.date().nullable().required('Period start date is required'),
    periodEnd: yup.date().nullable().required('Period end date is required'),
  });

  const formik = useFormik({
    initialValues: {
      userId: '',
      employeeId: '',
      workerId: '',
      assignmentId: '',
      assignmentName: '',
      supplierName: '',
      invoiceNumber: '',
      jobTitle: '',
      hireType: '',
      invoiceDate: null,
      periodStart: null,
      periodEnd: null,
      invoiceAmount: '',
      totalUnits: '',
      totalHours: '',
      billRate: '',
      payRate: '',
      rateMarkup: '',
      status: '',
      currency: '',
      attachments: [],
      approverEmail: '',
      approverName: '',
      notes: '',
      // ✅ NEW FIELDS
      clientId: '',
      clientName: '',
      companyName: '',
      employmentCategory: '',
      billingContactName: '',
      workingCity: '',
      workingState: '',
      address1: '',
      payOvertimeExempt: '',
      overtimePayRate: '',
      hoursPerWeek: '',
      contractStartDate: null,
      contractEndDate: null,
      managerName: '',
      managerEmail: '',
      coApproverName: '',
      coApproverEmail: '',
      assignmentType: '',
      workerPayCompany: '',
      payModel: '',
      expensesEnabled: false,
      candidateCity: '',
      candidateState: '',
      // latest fields
      division: '',
      overtime: '',
      otCalculation: '',
      overtimeEligibility: '',
      markupPercent: '',
      w2Type: '',
      workMode: '',
      costCenterId: '',
      costCenterName: '',
      departments: '',
      merId: '',
      purchaseOrder: '',
      billingCompany: '',
      billingAddress1: '',
      billingAddress2: '',
      billingCity: '',
      billingState: '',
      billingCounty: '',
      billingCountry: '',
      postalCode: '',
      billAddressSameAsWorkAddress: '',
      projectCode: '',
      assignmentStatus: '',
      billingPostalCOde: '',
      glCode: '',
      externalReferenceId: '',
    },
    validationSchema,
    // validateOnMount: true,
    // validateOnChange: true,
    // validateOnBlur: true,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async (values: InvoiceFormValues) => {
      try {
        const formData = new FormData();
        formData.append('assignmentId', values.assignmentId || '');
        formData.append('userId', selectedUserId || '');

        formData.append('assignmentName', values.assignmentName || '');
        // formData.append('clientId', values.clientId || '');
        formData.append('clientName', values.clientName || '');
        formData.append('supplierName', values.supplierName || '');
        // formData.append('invoiceDate', values.invoiceDate ? toISODate(values.invoiceDate) : '');
        formData.append('invoiceDate', formatDateOnly(values.invoiceDate));
        formData.append('invoiceNumber', values.invoiceNumber || '');
        formData.append('jobTitle', values.jobTitle || '');
        formData.append('hireType', values.hireType || '');

        formData.append('periodStart', formatDateOnly(values.periodStart));
        formData.append('periodEnd', formatDateOnly(values.periodEnd));

        formData.append('status', values.status || '');
        formData.append('invoiceAmount', values.invoiceAmount || '');
        formData.append('totalUnits', values.totalUnits || '');
        formData.append('totalHours', values.totalHours || '');
        formData.append('billRate', values.billRate || '');
        formData.append('payRate', values.payRate || '');
        formData.append('rateMarkup', values.rateMarkup || '');
        formData.append('notes', values.notes || '');
        formData.append('currency', values.currency || '');
        formData.append('approverEmail', values.approverEmail || '');
        formData.append('approverName', values.approverName || '');

        // --- older FIELDS
        formData.append('companyName', values.companyName || '');
        formData.append('clientId', values.clientId || '');
        formData.append('employmentCategory', values.employmentCategory || '');
        formData.append('billingContactName', values.billingContactName || '');
        formData.append('workingCity', values.workingCity || '');
        formData.append('workingState', values.workingState || '');

        formData.append('payOvertimeExempt', values.payOvertimeExempt || '');

        formData.append('overtimePayRate', values.overtimePayRate ? String(values.overtimePayRate) : '');

        formData.append('hoursPerWeek', values.hoursPerWeek ? String(values.hoursPerWeek) : '');

        formData.append('contractStartDate', values.contractStartDate ? toISODate(values.contractStartDate) : '');

        formData.append('contractEndDate', values.contractEndDate ? toISODate(values.contractEndDate) : '');

        formData.append('managerName', values.managerName || '');
        formData.append('managerEmail', values.managerEmail || '');
        formData.append('coApproverName', values.coApproverName || '');
        formData.append('coApproverEmail', values.coApproverEmail || '');

        formData.append('assignmentType', values.assignmentType || '');
        formData.append('workerPayCompany', values.workerPayCompany || '');
        formData.append('payModel', values.payModel || '');

        formData.append('expensesEnabled', values.expensesEnabled ? '1' : '0');

        formData.append('candidateCity', values.candidateCity || '');
        formData.append('candidateState', values.candidateState || '');

        // latest fields
        formData.append('divison', values.division || '');
        formData.append('overtime', values.overtime || '');
        formData.append('otCalculation', values.otCalculation || '');
        formData.append('overtimeEligibility', values.overtimeEligibility || '');

        formData.append('markupPercent', values.markupPercent || '');
        formData.append('w2Type', values.w2Type || '');
        formData.append('workMode', values.workMode || '');

        formData.append('costCenterId', values.costCenterId || '');
        formData.append('costCenter', values.costCenterName || '');

        formData.append('department', values.departments || '');

        formData.append('merId', values.merId || '');
        formData.append('purchaseOrder', values.purchaseOrder || '');

        formData.append('billingCompany', values.billingCompany || '');

        formData.append('billingAddress1', values.billingAddress1 || '');
        formData.append('billingAddress2', values.billingAddress2 || '');

        formData.append('billingCity', values.billingCity || '');
        formData.append('billingState', values.billingState || '');
        formData.append('billingCounty', values.billingCounty || '');
        formData.append('billingCountry', values.billingCountry || '');

        formData.append('postalCode', values.postalCode || '');
        formData.append('assignmentStatus', values.assignmentStatus || '');

        formData.append('billAddressSameAsWorkAddress', values.billAddressSameAsWorkAddress ? '1' : '0');
        formData.append('billingPostalCOde', values.billingPostalCOde ? '1' : '0');
        formData.append('glCode', values.glCode ? '1' : '0');
        formData.append('externalReferenceId', values.externalReferenceId ? '1' : '0');

        uploadedFiles.forEach(file => {
          formData.append('attachments', file);
        });

        console.log('formData', formData);
        await addInvoice.mutateAsync({ invoice: formData });
        navigate('/invoices');
      } catch (error) {
        console.error('Error during submission of Ticket', error);
      }
    },
  });

  const handleAssignmentSelect = (assignmentId: string) => {
    formik.setFieldValue('assignmentId', assignmentId, true);
    formik.setFieldTouched('assignmentId', true, true);

    const assignment = assignmentsUser.find((a: any) => a.ASSIGNMENT_ID === assignmentId);
    if (!assignment) return;

    applyAssignmentToForm(assignment);
  };

  const applyAssignmentToForm = (assignment: any) => {
    const parsedStartDate = assignment.CONTRACT_START_DATE ? new Date(assignment.CONTRACT_START_DATE) : null;
    const parsedEndDate = assignment.CONTRACT_END_DATE ? new Date(assignment.CONTRACT_END_DATE) : null;

    setContractStartDate(parsedStartDate);
    setContractEndDate(parsedEndDate);

    formik.setFieldValue('workerId', assignment.EMPLOYEEID ?? '');
    formik.setFieldValue('assignmentId', assignment.ASSIGNMENT_ID ?? '');

    if (assignment.PAY_START_DATE) {
      const payStart = new Date(assignment.PAY_START_DATE);
      console.log('payStart', payStart);
      setMinPeriodStartDate(payStart);

      // If already selected periodStart is before payStart, reset it
      if (formik.values.periodStart && new Date(formik.values.periodStart) < payStart) {
        formik.setFieldValue('periodStart', null);
      }
    } else {
      setMinPeriodStartDate(null);
    }

    formik.setFieldValue(
      'assignmentName',
      `${assignment.JOBTITLE} (${assignment.ASSIGNMENT_ID}) - ${assignment.CLIENT_NAME}`
    );

    formik.setFieldValue('clientId', assignment.JOB_CLIENT_ID ?? '');
    formik.setFieldValue('clientName', assignment.CLIENT_NAME ?? '');

    // If you don’t have these from API yet, keep empty for now
    // formik.setFieldValue('companyName', assignment.COMPANYID ?? '');
    formik.setFieldValue('companyName', assignment.COMPANY_NAME ?? '');

    formik.setFieldValue('supplierName', assignment.WORKER_PAY_COMPANY ?? '');

    formik.setFieldValue('jobTitle', assignment.JOBTITLE ?? '');
    formik.setFieldValue('hireType', assignment.HIRETYPE ?? '');

    formik.setFieldValue('billRate', String(assignment.BILL_RATE ?? ''));
    formik.setFieldValue('payRate', String(assignment.PAY_RATE ?? ''));
    formik.setFieldValue('rateMarkup', String(assignment.MARKUP_PERCENT ?? ''));

    formik.setFieldValue('currency', assignment.CURRENCY ?? 'USD');

    formik.setFieldValue('approverEmail', assignment.APPROVER_EMAIL ?? '');
    formik.setFieldValue('approverName', assignment.ASSIGNMENT_APPROVER_NAME ?? '');

    formik.setFieldValue('employmentCategory', assignment.EMPLOYMENT_CATEGORY ?? '');
    formik.setFieldValue('billingContactName', assignment.BILLING_CONTACT ?? '');
    formik.setFieldValue('workingCity', assignment.WORKING_CITY ?? '');
    formik.setFieldValue('workingState', assignment.WORKING_STATE ?? '');
    formik.setFieldValue('address1', assignment.BILLING_ADDRESS1 ?? '');
    formik.setFieldValue('payOvertimeExempt', assignment.PAY_OVERTIME_EXEMPT ?? '');
    formik.setFieldValue('overtimePayRate', assignment.OVERTIME_PAY_RATE ?? '');
    formik.setFieldValue('hoursPerWeek', assignment.HOURSPERWEEK ?? '');
    formik.setFieldValue('managerName', assignment.MANAGER_NAME ?? '');
    formik.setFieldValue('managerEmail', assignment.MANAGER_EMAIL ?? '');
    formik.setFieldValue('coApproverName', assignment.BACKUP_APPROVER_NAME ?? '');
    formik.setFieldValue('coApproverEmail', assignment.BACKUP_APPROVER_EMAIL ?? '');
    formik.setFieldValue('assignmentType', assignment.ASSIGNMENT_TYPE ?? '');
    formik.setFieldValue('workerPayCompany', assignment.WORKER_PAY_COMPANY ?? '');
    formik.setFieldValue('payModel', assignment.PAY_MODEL ?? '');
    formik.setFieldValue('candidateCity', assignment.CANDIDATE_CITY ?? '');
    formik.setFieldValue('candidateState', assignment.CANDIDATE_STATE ?? '');

    // new fields
    formik.setFieldValue('division', assignment.DIVISION ?? '');
    formik.setFieldValue('overtime', assignment.OVERTIME ?? '');
    formik.setFieldValue('otCalculation', assignment.OT_CALCULATION ?? '');
    formik.setFieldValue('overtimeEligibility', assignment.OVERTIMEELIGIBILITY ?? '');

    formik.setFieldValue('markupPercent', assignment.MARKUP_PERCENT ?? '');
    formik.setFieldValue('w2Type', assignment.W2_TYPE ?? '');
    formik.setFieldValue('workMode', assignment.WORKMODE ?? '');

    formik.setFieldValue('costCenterId', assignment.COST_CENTER_ID ?? '');
    formik.setFieldValue('costCenterName', assignment.COST_CENTER_NAME ?? '');

    formik.setFieldValue('departments', assignment.Departments ?? '');

    formik.setFieldValue('merId', assignment.MERID ?? '');
    formik.setFieldValue('purchaseOrder', assignment.PURCHASE_ORDER ?? '');

    formik.setFieldValue('billingCompany', assignment.BILLING_COMPANY ?? '');

    formik.setFieldValue('billingAddress1', assignment.BILLING_ADDRESS1 ?? '');
    formik.setFieldValue('billingAddress2', assignment.BILLING_ADDRESS2 ?? '');

    formik.setFieldValue('billingCity', assignment.BILLING_CITY ?? '');
    formik.setFieldValue('billingState', assignment.BILLING_STATE ?? '');
    formik.setFieldValue('billingCounty', assignment.BILLING_COUNTY ?? '');
    formik.setFieldValue('billingCountry', assignment.BILLING_COUNTRY ?? '');

    formik.setFieldValue('postalCode', assignment.POSTAL_CODE ?? '');
    formik.setFieldValue('assignmentStatus', assignment.ASSIGNMENT_STATUS ?? '');

    formik.setFieldValue('billAddressSameAsWorkAddress', assignment.BILL_ADDRESS_SAME_AS_WORK_ADDRESS ?? '');
    // formik.setFieldValue('projectCode', assignment.Proe ?? '');
    formik.setFieldValue('billingPostalCOde', assignment.BILLING_ZIP ?? '');
    formik.setFieldValue('glCode', assignment.GL_CODE ?? '');
    formik.setFieldValue('externalReferenceId', assignment.VMS_ID ?? '');

    if (assignment.CONTRACT_START_DATE) {
      const start = new Date(assignment.CONTRACT_START_DATE);
      setContractStartDate(start);
      formik.setFieldValue('contractStartDate', start);
      formik.setFieldValue('assignmentStartDate', start);
    } else {
      setContractStartDate(null);
    }

    if (assignment.CONTRACT_END_DATE) {
      const end = new Date(assignment.CONTRACT_END_DATE);
      setContractEndDate(end);
      formik.setFieldValue('contractEndDate', end);
      formik.setFieldValue('assignmentEndDate', end);
    } else {
      setContractEndDate(null);
    }
  };

  const fileInputRef = React.useRef<any>(null);
  const handleFileUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    setUploadedFiles(prevFiles => [...prevFiles, ...files]);
    formik.setFieldValue('fileUpload', files);
  };

  const handleFiles = (files: File[]) => {
    const updatedFiles = [...uploadedFiles, ...files];

    setUploadedFiles(updatedFiles);

    // Update Formik attachments
    formik.setFieldValue('attachments', updatedFiles);
  };

  const handleFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const files = Array.from(event.dataTransfer.files || []);

    handleFiles(files);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
    formik.setFieldValue('fileUpload', updatedFiles);
  };

  const handleModuleChange = (event: React.ChangeEvent<HTMLSelectElement> | string) => {
    let selectedModule: string;

    if (typeof event === 'string') {
      selectedModule = event;
    } else {
      selectedModule = event.target.value;
    }

    const newSubCategories = supportDeskSubmodules[selectedModule] || [];

    formik.setFieldValue('module', selectedModule);

    const defaultSubCategory = newSubCategories.length > 0 ? newSubCategories[0].value : '';
    formik.setFieldValue('subCategory', defaultSubCategory);

    setSubCategoryOptions(newSubCategories);
  };

  const isWorker = true;

  const today = new Date();
  const effectiveMaxDate = contractEndDate && contractEndDate < today ? contractEndDate : today;

  return (
    <Container>
      {addInvoice.isLoading && <FullScreenLoading />}
      <HeaderItemLeft>
        <NavTextLink to={-1 as any}>
          <ArrowBack src={Arrow} />
        </NavTextLink>
        <PageTitle>Create Invoice</PageTitle>
      </HeaderItemLeft>
      <CardContainer>
        <HelpForm>
          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper
              style={{
                position: 'relative',
                width: '100%',
                overflow: 'visible',
                maxHeight: 'none',
              }}
            >
              <CommonInput
                label="Employee *"
                placeholder="Search employee"
                value={selectedEmployee ? `${selectedEmployee.firstName} ${selectedEmployee.lastName}` : employeeSearch}
                onChange={e => {
                  setSelectedEmployee(null);
                  setEmployeeSearch(e.target.value);
                }}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                }}
              />

              {employeeOptions.length > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    top: '70px',
                    width: '100%',
                    zIndex: 10,
                    background: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '7px',
                    maxHeight: '220px',
                    overflowY: 'auto',
                  }}
                >
                  {employeeOptions.map(option => (
                    <div
                      key={option.value}
                      onClick={() => handleEmployeeSelect(option.value as string)}
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                      }}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}

              <FormErrorWrap
                errorMessage={formik.errors.userId as string}
                visible={!!(formik.touched.userId && formik.errors.userId)}
              />
            </FormInputWrapper>
          </ModuleLine>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            {isWorker ? (
              ''
            ) : (
              <>
                <CommonInput
                  id="worker"
                  name="workerId"
                  label="Worker *"
                  placeholder="Search by name or email"
                  value={formik.values.workerId}
                  onChange={event => formik.setFieldValue('workerId', event.target.value)}
                  style={{
                    width: '100%',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                    boxSizing: 'border-box',
                  }}
                />
                <FormErrorWrap errorMessage={formik.errors.workerId as string} visible={!formik.errors.workerId} />
              </>
            )}
          </FormInputWrapper>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              {assignmentsLoading ? (
                <FullScreenLoading />
              ) : (
                <CommonDropdown
                  label="Assignment *"
                  id="assignmentId"
                  name="assignmentId"
                  options={assignmentOptionsWithBlank}
                  value={formik.values.assignmentId}
                  setValue={handleAssignmentSelect}
                  selectStyle={{
                    width: '100%',
                    height: '35px',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                  }}
                  disabled={assignmentOptions.length === 0}
                />
              )}

              <FormErrorWrap
                errorMessage={formik.errors.assignmentId as string}
                visible={!!(formik.submitCount > 0 && formik.errors.assignmentId)}
              />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <DatePicker
                id="invoiceDate"
                name="invoiceDate"
                label="Invoice Date *"
                dateFormat="MM/dd/yyyy"
                autoComplete="off"
                maxDate={new Date()}
                selected={formik.values.invoiceDate ?? null}
                onChange={(val: Date | null) => formik.setFieldValue('invoiceDate', val)}
              />
              <FormErrorWrap
                errorMessage={formik.errors.invoiceDate as string}
                visible={!!(formik.touched.invoiceDate && formik.errors.invoiceDate)}
              />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="invoiceNumber"
                name="invoiceNumber"
                label="Invoice Number"
                placeholder="External Reference ID"
                autoComplete="off"
                value={formik.values.invoiceNumber}
                onChange={event => formik.setFieldValue('invoiceNumber', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap
                errorMessage={formik.errors.invoiceNumber as string}
                visible={!!(formik.touched.invoiceNumber && formik.errors.invoiceNumber)}
              />
            </FormInputWrapper>
          </ModuleLine>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              <DatePicker
                id="periodStart"
                name="periodStart"
                label="Period Start *"
                dateFormat="MM/dd/yyyy"
                autoComplete="off"
                selected={formik.values.periodStart ?? null}
                minDate={contractStartDate ?? undefined}
                maxDate={effectiveMaxDate}
                onChange={(val: Date | null) => formik.setFieldValue('periodStart', val)}
              />

              <FormErrorWrap errorMessage={formik.errors.periodStart as string} visible={!formik.errors.periodStart} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              <DatePicker
                id="periodEnd"
                name="periodEnd"
                label="Period End *"
                dateFormat="MM/dd/yyyy"
                autoComplete="off"
                selected={formik.values.periodEnd ?? null}
                // minDate={formik.values.periodStart ?? undefined}
                minDate={formik.values.periodStart ?? contractStartDate ?? undefined}
                // maxDate={contractEndDate ?? undefined}
                maxDate={effectiveMaxDate}
                onChange={(val: Date | null) => formik.setFieldValue('periodEnd', val)}
              />
              <FormErrorWrap errorMessage={formik.errors.periodEnd as string} visible={!formik.errors.periodEnd} />
            </FormInputWrapper>
          </ModuleLine>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="invoiceAmount"
                name="invoiceAmount"
                label="Invoice Amount *"
                placeholder="Money"
                autoComplete="off"
                value={formik.values.invoiceAmount}
                onChange={event => formik.setFieldValue('invoiceAmount', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap
                errorMessage={formik.errors.invoiceAmount as string}
                visible={!formik.errors.invoiceAmount}
              />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="totalUnits"
                name="totalUnits"
                label="Total Units/Hours *"
                placeholder="Number"
                autoComplete="off"
                value={formik.values.totalUnits}
                onChange={event => formik.setFieldValue('totalUnits', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap errorMessage={formik.errors.totalUnits as string} visible={!formik.errors.totalUnits} />
            </FormInputWrapper>

            {/* <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="totalHours"
                name="totalHours"
                label="Total Hours"
                placeholder="Number"
                autoComplete="off"
                value={formik.values.totalHours}
                onChange={event => formik.setFieldValue('totalHours', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap errorMessage={formik.errors.totalHours as string} visible={!formik.errors.totalHours} />
            </FormInputWrapper> */}
          </ModuleLine>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '5px', position: 'relative' }}>
            <label
              htmlFor="fileUpload"
              style={{
                display: 'block',
                marginBottom: '5px',
                fontSize: '16px',
                color: '#222247',
              }}
            >
              Attachments *
            </label>
            <input
              ref={fileInputRef}
              id="fileUpload"
              name="Attachment"
              type="file"
              style={{
                display: 'none',
              }}
              onChange={handleFileChange}
            />
            <div
              style={{
                width: '100%',
                height: '136px',
                border: '1px solid #ccc',
                borderRadius: '7px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative',
                marginBottom: '0px',
                boxSizing: 'border-box',
              }}
              onClick={handleFileUploadClick}
              onDragOver={event => {
                event.preventDefault();
                event.stopPropagation();
              }}
              onDrop={handleFileDrop}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  font: '18px/27px Biotif',
                }}
              >
                <span
                  style={{
                    color: '#4A4BA9',
                    fontWeight: 'bold',
                    marginRight: '5px',
                  }}
                >
                  Add files
                </span>
                <span
                  style={{
                    color: '#222247',
                    opacity: 0.5,
                  }}
                >
                  Or drop files here
                </span>
              </div>
            </div>
            <FormErrorWrap errorMessage={formik.errors.attachments as string} visible={!!formik.errors.attachments} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginTop: '0px' }}>
            <div
              style={{
                width: '55%',
                marginTop: '0px',
                paddingTop: '0px',
                borderRadius: '7px',
              }}
            >
              {uploadedFiles.map((file, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#4A4BA9',
                      textDecoration: 'none',
                      marginRight: '10px',
                      fontSize: '12px',
                    }}
                  >
                    {file?.name}
                  </a>
                  <span
                    onClick={() => handleRemoveFile(index)}
                    style={{
                      color: '#4A4BA9',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <label htmlFor="description" style={{ display: 'block', marginBottom: '5px' }}>
              Notes
            </label>
            <textarea
              id="notes"
              name="notes"
              placeholder="Notes"
              value={formik.values.notes}
              onChange={event => formik.setFieldValue('notes', event.target.value)}
              style={{
                width: '100%',
                height: '136px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
                padding: '10px',
                resize: 'none',
                fontSize: '14px',
                textAlign: 'left',
                verticalAlign: 'top',
              }}
            />
            <FormErrorWrap
              errorMessage={formik.errors.notes as string}
              visible={!!(formik.touched.notes && formik.errors.notes)}
            />
          </FormInputWrapper>

          <FormInputWrapper
            style={{ flex: '0 0 100%', display: 'flex', justifyContent: 'flex-start', marginBottom: '5px' }}
          >
            <RegularButton
              onClick={() => {
                formik.setFieldValue('status', 'Submitted');
                formik.handleSubmit();
              }}
              disabled={addInvoice.isLoading}
            >
              Submit
            </RegularButton>

            <RegularButton
              onClick={() => {
                formik.setFieldValue('status', 'Draft');
                formik.handleSubmit();
              }}
              disabled={addInvoice.isLoading}
            >
              Draft
            </RegularButton>
          </FormInputWrapper>
        </HelpForm>
      </CardContainer>
    </Container>
  );
};

export default CreateInvoice;
